<template>
  <v-col cols="12" class="px-8" v-if="permisoVista('reporterendimiento','r')">
    <v-row>
      <v-col :cols="(nombreEmpresa == 'Nyx' || nombreEmpresa == 'Glm') ? 4 : 12">
        <datePicker
          v-model="fecha"
          label="Fecha (Obligatorio)"
          format="YYYY-MM-DD"
          clearable
          maxToday
          @input="ejecutar"
        ></datePicker>
      </v-col>
      <v-col :cols="(nombreEmpresa == 'Nyx' || nombreEmpresa == 'Glm') ? 4 : 0">
        <v-autocomplete v-model="area" label="Área" :items="areas" item-text="nombre" item-value="idArea" clearable/>
      </v-col>
      <v-col :cols="(nombreEmpresa == 'Nyx' || nombreEmpresa == 'Glm') ? 4 : 0">
        <v-autocomplete v-model="turno" label="Turno" :items="turnos" item-text="nombre" item-value="idTurno" clearable/>
      </v-col>
      <v-col cols="12">
        <v-btn @click="ejecutar" color="primary" :loading="loading">Buscar</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="realizarPeticion" class="px-0 ma-0">
      <v-col cols="12" class="ma-0 text-right text-subtitle-2">
        Proxima Actualización en {{tiempo}}
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="loading"
			color="primary"
			indeterminate
		></v-progress-linear>
    <apexchart v-if="nombreEmpresa != 'Nyx' && nombreEmpresa != 'Glm'" type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
    <apexchart v-else type="bar" height="350" :options="chartOptions1" :series="series1"></apexchart>
  </v-col>
</template>


<script>
import axios from "axios";
import VTextFieldDatetime from '@/components/VTextFieldDatetime.vue';
import { mapState } from "vuex";

export default {
  components:{
    'v-text-field-datetime': VTextFieldDatetime,
  },
  data: () => ({
    categories:[],
    categories1: [],
    series:[],
    series1: [],

    fecha: null,
    area: null,
    turno: null,


    intervalo: null,
    loading: false,
    segundos: 0,
    areas: [],
    turnos: [],

    loadingAreas: false,
    loadingTurnos: false,
  }),
  computed:{
    ...mapState({
      nombreEmpresa: "nombreEmpresa"
    }),
    chartOptions(){
      return {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '100%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        yaxis: {
          title: {
            text: "Horas"
          } 
        },
        xaxis: {
          categories: this.categories,
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val.toFixed(2) + " hrs"
            }
          }
        },
        legend: {
          onItemClick: {
              toggleDataSeries: false
          }
        }
      }
    },
    chartOptions1() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end', // 'around', 'end'
            borderRadiusWhenStacked: 'last', // 'all', 'last'
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          },
        },
        xaxis: {
          categories: this.categories1,
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      }
    },
    urlDatos(){
      return (this.nombreEmpresa === "Nyx" || this.nombreEmpresa === 'Glm')
        ? `/Reportes/ReporteInactividadMaquinaNyx?desde=${this.fecha}` +
          (this.area ? `&idarea=${this.area}` : "") +
          (this.turno ? `&idturno=${this.turno}` : "")
        : `/Reportes/ReporteInactividadMaquina?desde=${this.fecha}`;
    },
    realizarPeticion(){
      return this.$utils.isValid(this.fecha);
    },
    tiempo(){
      return this.$utils.strings.toTime(this.segundos);
    }
  },
  mounted(){
    this.getDatos();
    this.getAreas();
    this.getTurnos();
    this.intervalo = setInterval(() => {
      if(this.segundos == 0){
        this.getDatos();
      }
      else{
        this.segundos -= 1;
      }
    },1000);
  },
  destroyed(){
    clearInterval(this.intervalo);
    this.intervalo = null;
  },
  methods:{
    ejecutar(){
      if(this.realizarPeticion)
      {
        this.getDatos();
      }
    },
    getDatos(){
      if(!this.realizarPeticion) return;
      this.loading = true;
      this.segundos = 60;

      axios
      .get(this.urlDatos)
      .then(response => {
        if(this.nombreEmpresa != 'Nyx' && this.nombreEmpresa != 'Glm') {
          this.series = response.data.series;
          this.categories = response.data.categories;
        } else {
            this.series1 = response.data.series;
            this.categories1 = response.data.categories;
        }
        
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getAreas() {
      this.loadingAreas = true;
      axios
        .get("/Areas")
        .then(response => this.areas = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingAreas = false;
        })
    },
    getTurnos() {
      this.loadingTurnos = true;
      axios
        .get("/Turnos")
        .then(response => this.turnos = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingTurnos = false;
        })
    },
  },
}
</script>